import { connect } from 'react-redux'
import {
  addArray as addUsersArray
} from 'store/redux/users'
import {
  addArray as addUserGroupArray
} from 'store/redux/userGroups'
import LayoutUsers from './LayoutUsers'

export default connect(
  null,
  {
    addUsersArray,
    addUserGroupArray
  }
)(LayoutUsers)
